import { forwardRef } from 'react'
import { SVGProps } from 'react'
import './button.scss'

type ButtonType = {
	title?: string
	onClick?: () => void
	type?: 'button' | 'submit' | 'reset'
	classes?: string
	disabled?: boolean
	icon?: string
	iconSVG?: SVGProps<SVGElement>
	iconPosition?: 'right' | 'left'
	testId?: string
	testIdIcon?: string
	uppercase?: boolean
	href?: false | string
	target?: string
	children?: any
}

export type Ref = HTMLButtonElement

const Button = forwardRef<Ref, ButtonType>((props, ref) => {
	const {
		title,
		onClick,
		type = 'button',
		classes,
		disabled = false,
		icon,
		iconSVG,
		iconPosition = 'right',
		testId,
		testIdIcon,
		uppercase = false,
		href = false,
		target = '_blank',
		children
	} = props

	const content = (
		<>
			{iconPosition === 'left' &&
				((icon && <i className={icon} data-testid={testIdIcon} />) || iconSVG)}
			{title}
			{children}
			{iconPosition === 'right' &&
				((icon && <i className={icon} data-testid={testIdIcon} />) || iconSVG)}
		</>
	)

	return (
		<>
			{href ? (
				<a
					data-testid={testId}
					type={type}
					className={`
						a-button 
						${disabled && 'disabled'} 
						${classes || ''}
						${uppercase && 'uppercase'}
					`}
					href={href}
					target={target}
				>
					{content}
				</a>
			) : (
				<button
					data-testid={testId}
					type={type}
					className={`
						a-button 
						${disabled && 'disabled'} 
						${classes || ''}
						${uppercase && 'uppercase'}
					`}
					onClick={() => onClick?.()}
					ref={ref}
				>
					{content}
				</button>
			)}
		</>
	)
})

export default Button
